import { render, staticRenderFns } from "./dropdown-list.vue?vue&type=template&id=549615bb"
import script from "./dropdown-list.vue?vue&type=script&lang=js"
export * from "./dropdown-list.vue?vue&type=script&lang=js"
import style0 from "./dropdown-list.vue?vue&type=style&index=0&id=549615bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports